export const sortBy = { // Always must be in same order - populat, alphabetical, new arrivals
    EN: [
        {
            name: 'Popular', val: 'Popular'
        },
        {
            name: 'Alphabetical', val: 'Alphabetical'
        },
        {
            name: 'New Arrivals', val: 'New Arrivals'
        }
    ],
    FR: [
        {
            name: 'Ordre de popularité', val: 'Ordre de popularité'
        },
        {
            name: 'Ordre alphabétique', val: 'Ordre alphabétique'
        },
        {
            name: 'Nouveautés', val: 'Nouveautés'
        }
    ],
    PL: [
        {
            name: 'Według popularności', val: 'Według popularności',
        },
        {
            name: 'Alfabetycznie', val: 'Alfabetycznie'
        },
        {
            name: 'Nowości', val: 'Nowości'
        }
    ],
    DE: [
        {
            name: 'Beliebt', val: 'Beliebt',
        },
        {
            name: 'Alphabetisch', val: 'Alphabetisch'
        },
        {
            name: 'Die neuesten Modelle', val: 'Die neuesten Modelle'
        }
    ]
}

export const colorRangeAll = {
    EN: 'All Colors',
    FR: 'Toutes Les Couleurs',
    PL: 'Wszystkie kolory',
    DE: 'Alle Farben'
}

export const colorGroupTransaltions = {
    'natural': {
        EN: 'Natural',
        FR: 'Naturel',
        PL: 'Naturalny',
        DE: 'Naturfarben'
    },
    'lightGrey': {
        EN: 'Light Grey',
        FR: 'Gris Clair',
        PL: 'Jasnoszary',
        DE: 'Hellgrau'
    },
    'brown': {
        EN: 'Brown',
        FR: 'Marron',
        PL: 'Brązowy',
        DE: 'Braun'
    },
    'darkGrey': {
        EN: 'Dark Grey',
        FR: 'Gris Foncé',
        PL: 'Ciemnoszary',
        DE: 'Dunkelgrau'
    },
    'sunset': {
        EN: 'Sunset',
        FR: 'Coucher de Soleil',
        PL: 'Zachód Słońca',
        DE: 'Sonnenuntergang'
    },
    'blue': {
        EN: 'Blue',
        FR: 'Bleu',
        PL: 'Niebieski',
        DE: 'Blau'
    },
    'green': {
        EN: 'Green',
        FR: 'Vert',
        PL: 'Zielony',
        DE: 'Grün'
    },
}

export const sofasTypesAll = {
    EN: 'All Types',
    FR: 'Tous Les Types',
    PL: 'Wszystkie rodzaje',
    DE: 'Alle Typen'
}

export const upholsterysArrAll = {
    EN: 'All Upholsteries',
    FR: 'Tous Les Revêtements',
    PL: 'Wszystkie wykończenia',
    DE: 'Alle Polsterungen'
}

export const covesArrAll = {
    EN: 'All Covers',
    FR: 'Toutes Les Housses',
    PL: 'Wszystkie poszycia',
    DE: 'Alle Bezüge'
}
export const texturesArrAll = {
    EN: "All Textures",
    FR: "Toutes Les Textures",
    PL: "Wszystkie tekstury",
    DE: "Alle Texturen"
}

export const featuresArrAll = {
    EN: "All Features",
    FR: "Toutes Les Fonctionnalités",
    PL: "Wszystkie cechy",
    DE: "Alle Funktionen"
}

export const clearAllTitle = {
    EN: 'Clear all filters',
    FR: 'Effacer tous les filtres',
    PL: 'Wyczyść wszystkie filtry',
    DE: 'Alle Filter löschen'
}

export const filterTitle = {
    EN: 'Filter',
    FR: 'Filtrer',
    PL: 'Filtr',
    DE: 'Filter'
}

export const sortByTitle = {
    EN: 'Sort by',
    FR: 'Trier par',
    PL: 'Sortuj według',
    DE: 'Sortieren nach'
}

export const colorRangeTitle = {
    EN: 'Color Range',
    FR: 'Couleurs',
    PL: 'Zakres kolorów',
    DE: 'Farbpalette'
}

export const texturesTitle = {
    EN: 'Textures',
    FR: 'Textures',
    PL: 'Tekstury',
    DE: 'Texturen'
}

export const featuresTitle = {
    EN: 'Features',
    FR: 'Caractéristiques',
    PL: 'Cechy',
    DE: 'Eigenschaften'
}

export const reset = {
    EN: 'RESET ALL',
    FR: 'TOUT EFFACER',
    PL: 'WYCZYŚĆ WSZYSTKO',
    DE: 'ALLE ZURÜCKSETZEN'
}

export const view = {
    EN: 'VIEW',
    FR: 'VOIR',
    PL: 'WIDOK',
    DE: 'ANSEHEN'
}

export const sortFilterTitle = {
    EN: 'Sort & Filter',
    FR: 'Trier et filtrer',
    PL: 'Sortuj i filtruj',
    DE: 'Sortieren und filtern'
}

export const noResultTitle = {
    EN: 'No results',
    FR: 'Aucun résultat',
    PL: 'Brak wyników',
    DE: 'Keine Ergebnisse'
}

export const noResultMessage = {
    EN: `We couldn’t find any matches for your filters.`,
    FR: `Nous n’avons trouvé aucun résultat correspondant à vos recherches.`,
    PL: `Nie znaleźliśmy żadnych pasujących wyników.`,
    DE: 'Wir konnten nichts Passendes für Ihre Filter finden.'
}

export const sortParamName = {
    EN: 'sort',
    FR: 'trier',
    PL: 'sortuj',
    DE: 'sortieren'
}

export const colorParamName = {
    EN: 'color',
    FR: 'couleur',
    PL: 'kolor',
    DE: 'Farbe'
}

export const texturesParamName = {
    EN: 'textures',
    FR: 'textures',
    PL: 'tekstury',
    DE: 'Strukturen'
}

export const featuresParamName = {
    EN: 'features',
    FR: 'caractéristiques',
    PL: 'cechy',
    DE: 'Eigenschaften'
}

export const searchParamName = {
    EN: 'search',
    FR: 'recherche',
    PL: 'szukaj',
    DE: 'Suchen'
}

export const pageParamName = {
    EN: 'page',
    FR: 'page',
    PL: 'strona',
    DE: 'Seite'
}

export const typeParamName = {
    EN: 'type',
    FR: 'type',
    PL: 'typ',
    DE: 'typ'
}

export const coverParamName = {
    EN: 'cover',
    FR: 'housse',
    PL: 'poszycie',
    DE: 'Bezug'
}

export const upholsteryParamName = {
    EN: 'upholstery',
    FR: 'rembourrage',
    PL: 'tapicerka',
    DE: 'Polsterung'
}

export const upholsterysTitle = {
    EN: 'Type of upholstery',
    FR: 'Type de rembourrage',
    PL: 'Rodzaj wykończenia',
    DE: 'Typ des Polsters'
}

export const coversTitle = {
    EN: 'Type of cover',
    FR: 'Type de housse',
    PL: 'Rodzaj poszycia',
    DE: 'Typ des Bezugs'
}

export const typeTitle = {
    EN: 'Type of sofa',
    FR: 'Type de canapé',
    PL: 'Rodzaj sofy',
    DE: 'Typ des Sofas'
}